import React from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { addExtras } from 'apps/auth/actions/extraAction';
import { AccountsList } from 'apps/auth/components/common/AccountsList/AccountsList';
import { CardSmall } from 'apps/auth/components/common/Card/CardSmall';
import { LinkedLine } from 'apps/auth/components/common/Card/LinkedLine';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { AUTH_GA_CARDS } from 'apps/auth/constants/UrlConstants';
import { requestLinkCardToAccount } from 'apps/auth/services/GaCardsService';

import AccountPlashka from './AccountPlashka';

const AccountLinkingScreen = (props) => {
    const linkCardToAccount = requestLinkCardToAccount({
        toggleSpinner: props.toggleSpinner,
        setScreenSuccess: props.setScreenSuccess,
        setScreen: props.setScreen,
        addExtras: props.addExtras,
        url: props.url,
    });
    return (
        <CommonPage showChat={false} backUrl={AUTH_GA_CARDS} stateOptions={{ isGA: true }}>
            <HeaderPanel title={props.title} subtitle={props.subTitle} />
            <CardSmall isPurple={props.isPurple} isLinked cardText={props.cardText} />
            <LinkedLine />
            <AccountsList isLinked>
                {props.accounts.map((account, index) => {
                    return <AccountPlashka key={`${account.pocketCurrency.title}${index}`} account={account} onClickHandler={linkCardToAccount} />;
                })}
            </AccountsList>
        </CommonPage>
    );
};
export default connect(null, { toggleSpinner, addExtras })(AccountLinkingScreen);
